import Macy from 'macy';

import Component from '../../components/component/component';
import { debounce, DebouncedFunction } from '../../components/helpers/helpers';

import './gallery.scss';

export default class Gallery extends Component {
    static initSelector: string = '.gallery';

    public list: JQuery;
    public items: JQuery;
    public titleContainer: JQuery;
    public isAlternate: boolean;
    public debouncedResizeHandler: DebouncedFunction<() => void>;
    public macy: Macy;
    public images: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.list = this.element.find('.gallery__list');
        this.items = this.element.find('.gallery__item');
        this.titleContainer = this.element.find('.gallery__title-container');
        this.isAlternate = this.element.hasClass('gallery--tertiary') || this.element.hasClass('gallery--quaternary');
        this.images = this.element.find('.image__img, .gallery__item');

        this.init();
    }

    init(): void {
        this.macy = Macy({
            /* eslint-disable */ // this lets the breakpoints stay in numerical order
            breakAt: {
                768: 3,
                1024: 4,
                1280: 5,
            },
            /* eslint-enable */
            columns: 2,
            container: this.list[0],
            margin: 0,
            mobileFirst: true,
            trueOrder: false,
            waitForImages: true,
        });

        const observer: MutationObserver = new MutationObserver(() => {
            this.macy.recalculate(true, true);
        });

        this.images.each((_index: number, element: HTMLElement) => {
            const target: JQuery = $(element);

            observer.observe(target[0], {
                attributeFilter: ['class'],
                attributes: true,
                characterData: false,
                childList: false,
            });
        });

        if (this.isAlternate) {
            this.offsetHandler();
            this.debouncedResizeHandler = debounce(this.offsetHandler.bind(this), 50);
            $(window).on('resize', this.debouncedResizeHandler.bind(this));
        }
    }

    offsetHandler(): void {
        if (window.matchMedia('(min-width: 1280px)').matches) {
            const columns: JQuery = this.element.hasClass('gallery--tertiary') ? this.items.slice(0, 3) : this.items.slice(2, 5);
            const titleContainerHeight: number = this.titleContainer.innerHeight();

            this.list.css('margin-top', (titleContainerHeight + 100) * -1);

            this.paddingHandler(columns);
        } else if (window.matchMedia('(min-width: 1024px)').matches) {
            const columns: JQuery = this.element.hasClass('gallery--tertiary') ? this.items.slice(0, 2) : this.items.slice(2, 4);
            const titleContainerHeight: number = this.titleContainer.innerHeight();

            this.list.css('margin-top', (titleContainerHeight + 100) * -1);

            if (this.element.hasClass('gallery--tertiary')) {
                this.items.slice(2, 3).css('padding-top', '');
            } else {
                this.items.slice(4, 5).css('padding-top', '');
            }
            this.paddingHandler(columns);
        } else {
            this.list.css('margin-top', '');
            this.items.css('padding-top', '');
        }
    }

    paddingHandler(items: JQuery): void {
        items.each((_index: number, element: HTMLElement) => {
            const target: JQuery = $(element);
            const offsetValue: number = (this.titleContainer.innerHeight() + 50);

            target.css('padding-top', '');
            const currentTopPadding: number = target.innerHeight() - target.height();

            target.css('padding-top', offsetValue + currentTopPadding);
        });
    }
}
